export default "__VITE_ASSET__BnCdlveG__"